export default "__VITE_ASSET__C_wCp1nl__"